import { render, staticRenderFns } from "./ProductsTablePrice.vue?vue&type=template&id=465e08b1&"
import script from "./ProductsTablePrice.vue?vue&type=script&lang=js&"
export * from "./ProductsTablePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports